import { COUNTRY } from '@/utils/locale';
import { getConfig } from '@/config/core';
export const ChatbotConfig = {
  sessionArea: {},
  inputArea: {
    enable: (props: any, cid: string) => {
      const initStore = props?.initStore || props?.firstInit?.initStore;
      const NO_INPUT_REGIONS = getConfig()?.noInputRegions;
      if (NO_INPUT_REGIONS.includes(cid) && initStore?.isDirectToLiveChatForNewMarket !== false && !props?.agentStore?.inAgent) {
        return false;
      }

      return true;
    },
  },
  shortcut: {
    enable: (props: any, cid: string) => {
      const NO_INPUT_REGIONS = getConfig()?.noInputRegions;
      return !NO_INPUT_REGIONS.includes(cid) || props?.initStore?.isDirectToLiveChatForNewMarket === false;
    },
  },
  noRealChatbot: {
    enable: (props: any, cid: string) => {
      const NO_INPUT_REGIONS = getConfig()?.noInputRegions;
      return NO_INPUT_REGIONS.includes(cid) && props?.initStore?.isDirectToLiveChatForNewMarket === false;
    },
  },
};

export const initStoreData = { agent: { inAgent: false }};

export function applyChatbotConfig(namespace: keyof typeof ChatbotConfig, props?: any) {
  const config = ChatbotConfig[namespace] || {};
  return Object.entries(config).map(([key, value]) => {
    if (typeof value === 'function') {
      return [key, value(props, COUNTRY)];
    }
    return [key, value];
  }).reduce((acc, cur) => ({
    ...acc,
    [cur[0] as string]: cur[1],
  }), {});
}
